import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class commonService {
  private baseUrl = environment._url; // 🔥 set environment later

  constructor(private http: HttpClient) {}

  // ✅ GET
  get(endpoint: string, params?: any): Observable<any> {
    return this.http.get(this.baseUrl + endpoint, { params });
  }

  getBlob(endpoint: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}${endpoint}`, {
      responseType: 'blob',
    });
  }

  // ✅ POST (JSON)
  post(endpoint: string, body: any): Observable<any> {
    return this.http.post(this.baseUrl + endpoint, body);
  }

  // ✅ POST FORM DATA (for file upload)
  postFormData(endpoint: string, formData: FormData): Observable<any> {
    return this.http.post(this.baseUrl + endpoint, formData);
  }

  // ✅ PATCH FORM DATA (for replacing an uploaded file)
  patchFormData(endpoint: string, formData: FormData): Observable<any> {
    return this.http.patch(this.baseUrl + endpoint, formData);
  }

  // ✅ POST FORM DATA with live upload-progress events — for a lesson video
  // /PDF upload bar. Subscribers switch on HttpEventType.UploadProgress
  // (event.loaded / event.total) and HttpEventType.Response (event.body).
  postFormDataWithProgress(endpoint: string, formData: FormData): Observable<HttpEvent<any>> {
    const req = new HttpRequest('POST', this.baseUrl + endpoint, formData, {
      reportProgress: true,
    });
    return this.http.request(req);
  }

  // ✅ PATCH FORM DATA with live upload-progress events (replacing a file).
  patchFormDataWithProgress(endpoint: string, formData: FormData): Observable<HttpEvent<any>> {
    const req = new HttpRequest('PATCH', this.baseUrl + endpoint, formData, {
      reportProgress: true,
    });
    return this.http.request(req);
  }

  // ✅ PUT
  put(endpoint: string, body: any): Observable<any> {
    return this.http.put(this.baseUrl + endpoint, body);
  }

  // ✅ DELETE
  delete(endpoint: string): Observable<any> {
    return this.http.delete(this.baseUrl + endpoint);
  }

  // ✅ PATCH
  patch(endpoint: string, body: any): Observable<any> {
    return this.http.patch(this.baseUrl + endpoint, body);
  }
}
